module.exports = __webpack_public_path__ + "static/media/setting.ac12e010.svg";